import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import { CheckCircleOutline } from '../../blocks/icons/CheckCircleOutline';
import { CheckCircleFilled } from '../../blocks/icons/CheckCircleFilled';
import { CheckCircleIndeterminate } from '../../blocks/icons/CheckCircleIndeterminate';
import styles from './MuiCheckbox.module.scss';
import useErrorScrollContext from '../../hooks/useErrorScrollContext';

export type MuiCheckboxProps = CheckboxProps & {
	error?: boolean;
};

const MuiCheckbox: React.FC<MuiCheckboxProps> = ( { error, ...props } ) => {
	const ref = useErrorScrollContext<HTMLButtonElement>( !!error );
	return (
		<Checkbox
			ref={ ref }
			icon={ <CheckCircleOutline className={ styles.svg } /> }
			checkedIcon={
				<CheckCircleFilled className={ [ styles.svg, styles.checked ].join( ' ' ) } />
			}
			indeterminateIcon={ <CheckCircleIndeterminate className={ styles.svg } /> }
			{ ...props }
			className={ [ styles.container, props.className ].join( ' ' ) }
		/>
	);
};

export default MuiCheckbox;
